import * as z from 'zod';
import { VALIDATION_MESSAGES } from '@/features/forms/validation';

const validationScheme = z
  .object({
    name: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    email: z.string().email({ message: VALIDATION_MESSAGES.email }),
    // areaCode: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    // phoneNumber: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    phone: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    phoneData: z.object({
      number: z.string(),
      countryName: z.any(),
      iso2: z.any(),
      dialCode: z.any(),
    }),
    dateDepart: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    paxNumber: z
      .string()
      .min(1, { message: VALIDATION_MESSAGES.required })
      .max(3, { message: VALIDATION_MESSAGES.maxLenght }),
    message: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    subscribeNews: z.boolean(),
  })
  .required();

export type FormInfoBookingDataType = z.infer<typeof validationScheme>;

export default validationScheme;
